export default {
  path: 'traffic-lights',
  name: 'TrafficLights',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TrafficLightsIndex.vue')
}
